import { render, staticRenderFns } from "./candidateMedical.vue?vue&type=template&id=5d0d88e0&"
import script from "./candidateMedical.vue?vue&type=script&lang=js&"
export * from "./candidateMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports